import React from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import EstateDashboardComponent from "../components/EstateDashboardComponent";

const EstateDashboard = () => {
    return (
        <Box h="100vh" display="flex" flexDirection="column">
            <Navbar />
            <Box flex="1" zIndex={1}>
                <EstateDashboardComponent />
            </Box>
        </Box>
    );
};

export default EstateDashboard;